"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
exports.colors = {
    neutral: {
        0: '#FFFFFF',
        50: '#FAFBFC',
        100: '#F7F8FD',
        150: '#F0F3F7',
        200: '#EDF1F8',
        250: '#DFE5EF',
        300: '#D6DCE7',
        350: '#C0CADB',
        400: '#99A5B9',
        450: '#78778D',
        500: '#555464',
        550: '#33333C',
        600: '#1D1D23',
    },
    primary: {
        350: '#5C6796',
        400: '#475074',
        450: '#31374E',
        500: '#1F2436',
        550: '#1A1E2B',
        600: '#12151F',
    },
    secondary: {
        50: '#ffc2cd',
        100: '#ffb3c1',
        200: '#ffa0b1',
        300: '#ff607d',
        400: '#ff385c',
    },
    accent: {
        green: {
            50: '#D4FCF1',
            100: '#9DDAC9',
            200: '#91D5B6',
            300: '#6CD5A5',
            400: '#46B984',
            500: '#51836C',
        },
        purple: {
            50: '#E1D3FF',
            100: '#C3A8FE',
            200: '#A880FF',
            300: '#8953FF',
            400: '#6333CC',
        },
        red: {
            50: "#FFE4E9",
            100: "#FFB3C1",
            200: "#FFA0B1",
            300: "#FF607D",
            400: "#FF385C",
            500: "#AE1833"
        }
    },
};
